import { styled } from '@mui/system'
import { Box } from '@mui/material'

export const FilterBox = styled(Box)(({ theme }) => ({
  whiteSpace: 'nowrap',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontSize: '13px',
  borderRadius: '4px',
  color: theme.palette.grey['800'],
  padding: '0 16px',
  fontWeight: '400',
  height: '32px',
  cursor: 'pointer',
  transition: 'all ease-in-out .2s',
}))

export const FilterCountChecked = styled(FilterBox)(
  ({ theme, isSelected }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '25%',
    color: isSelected ? theme.palette.primary.main : theme.palette.grey['500'],
    fontWeight: '400',
    padding: 8,
    height: '20px',
  })
)
